module.exports = __webpack_public_path__ + "static/media/bd.17331bc7.webp";